module.exports = __webpack_public_path__ + "static/media/jacuzzi-light-gray.99e2425c.svg";